// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = "https://nnleruzughmviocbvnwa.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Im5ubGVydXp1Z2htdmlvY2J2bndhIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NTYzMzczMzYsImV4cCI6MjA3MTkxMzMzNn0.9YQC6i5VLW0t-3unJKJ4MAD_-mlGZRqxjB910TDAjso";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY, {
  auth: {
    storage: localStorage,
    persistSession: true,
    autoRefreshToken: true,
  }
});